import moment from 'moment'
import React, { useEffect, useRef } from 'react'

const GoodTime = ({ value = undefined, max = '24:00', min = '00:00', onChange = () => { } }) => {

    const changeValue=(e)=>{
        const newValue=moment(e.target.value, 'HH:mm')
        const maxValue=moment(max, 'HH:mm')
        const minValue=moment(min, 'HH:mm')
        console.log(newValue, maxValue, minValue)
        if(newValue.diff(maxValue)<0&&newValue.diff(minValue)>0){
            onChange(e)
        }
    }


    return (
        <input className='form-control'
            type='time'
            value={value}
            onChange={changeValue}
        />
    )
}

export default GoodTime